var map = {
	"./bar-icon.svg": 51882,
	"./calendar-icon.svg": 45282,
	"./calendar.svg": 24872,
	"./call-icon-01.svg": 51077,
	"./call-icon-02.svg": 4178,
	"./call-icon-03.svg": 76266,
	"./call-incoming.svg": 76282,
	"./call-outgoing.svg": 2956,
	"./call-received.svg": 50163,
	"./call-remove.svg": 62394,
	"./camera-icon.svg": 42769,
	"./chat-foot-icon-01.svg": 54351,
	"./chat-foot-icon-02.svg": 61075,
	"./chat-foot-icon-03.svg": 86379,
	"./chat-foot-icon-04.svg": 77989,
	"./chat-icon-01.svg": 35887,
	"./chat-icon-02.svg": 20549,
	"./chat-icon-03.svg": 25721,
	"./chat-icon-04.svg": 63872,
	"./chat-icon-05.svg": 45646,
	"./chat-icon-06.svg": 96779,
	"./chat-icon-07.svg": 42442,
	"./chat-icon-08.svg": 62965,
	"./clip.svg": 19989,
	"./clock.svg": 81363,
	"./danger.svg": 57465,
	"./dep-icon-01.svg": 95353,
	"./dep-icon-02.svg": 27472,
	"./dep-icon-03.svg": 73213,
	"./dep-icon-04.svg": 79282,
	"./dep-icon-05.svg": 3206,
	"./doctor-dash-01.svg": 3173,
	"./doctor-dash-02.svg": 1545,
	"./doctor-dash-03.svg": 55743,
	"./doctor-dash-04.svg": 43192,
	"./document-icon.svg": 8598,
	"./draft.svg": 41397,
	"./edit-2.svg": 68955,
	"./edit.svg": 62365,
	"./empty-wallet.svg": 75921,
	"./folder-icon-01.svg": 23897,
	"./folder-icon-02.svg": 62023,
	"./folder-icon-03.svg": 5872,
	"./folder-icon-04.svg": 35911,
	"./folder-icon-05.svg": 96706,
	"./forward-icon-01.svg": 56225,
	"./forward-icon-02.svg": 25978,
	"./forward-icon-03.svg": 45238,
	"./gallery-icon.svg": 36303,
	"./health-img.svg": 57113,
	"./inbox.svg": 78720,
	"./login-icon-01.svg": 45411,
	"./login-icon-02.svg": 88010,
	"./login-icon-03.svg": 43414,
	"./logout.svg": 89999,
	"./mass-icon.svg": 92359,
	"./medal-01.svg": 13152,
	"./medal-02.svg": 33139,
	"./medal-03.svg": 83797,
	"./menu-icon-01.svg": 88981,
	"./menu-icon-02.svg": 97722,
	"./menu-icon-03.svg": 46354,
	"./menu-icon-04.svg": 8540,
	"./menu-icon-05.svg": 26027,
	"./menu-icon-06.svg": 7225,
	"./menu-icon-07.svg": 37169,
	"./menu-icon-08.svg": 91542,
	"./menu-icon-09.svg": 54602,
	"./menu-icon-10.svg": 7657,
	"./menu-icon-11.svg": 74387,
	"./menu-icon-12.svg": 68217,
	"./menu-icon-13.svg": 19821,
	"./menu-icon-14.svg": 89574,
	"./menu-icon-15.svg": 87756,
	"./menu-icon-16.svg": 21005,
	"./note-icon-01.svg": 77106,
	"./note-icon-02.svg": 61242,
	"./pdf-icon-01.svg": 84528,
	"./pdf-icon-02.svg": 65996,
	"./pdf-icon-03.svg": 63911,
	"./pdf-icon-04.svg": 19543,
	"./plus.svg": 94893,
	"./printer.svg": 42230,
	"./profile-add.svg": 83755,
	"./profile-user.svg": 15784,
	"./profile.svg": 86913,
	"./ram.svg": 22,
	"./re-fresh.svg": 39476,
	"./refresh-icon.svg": 52664,
	"./replay-01.svg": 2197,
	"./replay.svg": 57733,
	"./report-icon-01.svg": 23608,
	"./report-icon-02.svg": 31614,
	"./report-icon-03.svg": 29460,
	"./report-icon-04.svg": 75146,
	"./right-icon.svg": 12110,
	"./scissor.svg": 79953,
	"./search-normal.svg": 27441,
	"./sent.svg": 95736,
	"./setting-icon-01.svg": 60955,
	"./social-01.svg": 4552,
	"./social-02.svg": 50964,
	"./social-03.svg": 49630,
	"./social-04.svg": 6781,
	"./sort-icon-01.svg": 6077,
	"./sort-icon-02.svg": 590,
	"./star-empty.svg": 31296,
	"./star.svg": 55548,
	"./tag-icon-01.svg": 44045,
	"./tag-icon-02.svg": 90031,
	"./tag-icon-03.svg": 55331,
	"./tag-icon-04.svg": 40293,
	"./tag.svg": 89910,
	"./tick-circle.svg": 98340,
	"./timer.svg": 34766,
	"./trash.svg": 3996,
	"./user-icon.svg": 49465,
	"./video-icon-01.svg": 50334,
	"./video-icon-02.svg": 44964,
	"./video-icon-03.svg": 86353,
	"./voice-icon-01.svg": 55737,
	"./voice-icon-02.svg": 20465,
	"./voice-icon-03.svg": 86860,
	"./warning.svg": 46659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41199;